import Vue from 'vue';
import Moment from 'moment';
import parser from '../services/parser';
import ticketCheckMapper from '../services/ticketCheck/ticketMapper';
import { getSingleStake } from '../services/betslip';
import { rulesConstants, ticketTypes } from '../services/betslip/config';
import Helpers from '../services/helpers';

const updateMatchBets = (offerMatches, payload) => {
  const offerMatch = offerMatches.find(item => item.id === payload.idMatch);

  // match found
  if (offerMatch && offerMatch.id === payload.idMatch) {
    payload.matchBets.forEach((bet) => {
      const matchBet = offerMatch.bets.find(mb => mb.idMatchBet === bet.idMatchBet);

      // Bet found
      if (matchBet) {
        matchBet.active = bet.matchBetActive;
        // console.log('MATCH_BET_FOUND => ', offerMatch.shortName, '::', matchBet.name);

        // Go for outcome
        bet.matchBetOutcomes.forEach((bo) => {
          const matchBetOutcome = matchBet.outcomes
            .find(mbo => mbo.idMatchBetOutcome === bo.idMatchBetOutcome);

          if (matchBetOutcome) {
            // console.log(
            //   'MATCH_BET_OUTCOME_FOUND => ', offerMatch.shortName,
            //   '::',
            //   matchBet.name,
            //   '::',
            //   matchBetOutcome.name,
            //   '::',
            //   matchBetOutcome.value,
            //   '::',
            //   matchBetOutcome,
            //   '::',
            //   bo.matchBetOutcomeOddValue,
            // );

            matchBetOutcome.addOddIndicator(matchBetOutcome.value, bo.matchBetOutcomeOddValue);
            matchBetOutcome.value = parseFloat(bo.matchBetOutcomeOddValue).toFixed(2);
            matchBetOutcome.convertOdd();
          }

          return matchBetOutcome;
        });
      }
      return bet;
    });
  }
};

const updateBetslipBets = (betslipBets, updatedBets) => {
  const activeMatches = betslipBets.filter(bet => bet.matchId === updatedBets.idMatch);
  if (activeMatches.length) {
    // go trought found bets on betslip and match it with updated bets
    activeMatches.forEach((bb) => {
      const betslipBet = bb;
      const foundBet = updatedBets.matchBets.find(bet => bet.idMatchBet === betslipBet.idMatchBet);

      if (foundBet) {
        const foundOutcome = foundBet.matchBetOutcomes
          .find(outcome => outcome.idMatchBetOutcome === betslipBet.keyOutcome);

        if (foundOutcome) {
          if (parseFloat(betslipBet.oddValue) < parseFloat(foundOutcome.matchBetOutcomeOddValue)) {
            betslipBet.change = 'UP';
          } else if (parseFloat(betslipBet.oddValue)
            > parseFloat(foundOutcome.matchBetOutcomeOddValue)) {
            betslipBet.change = 'DOWN';
          }

          betslipBet.timeout = setTimeout(() => {
            betslipBet.change = null;
            clearTimeout(betslipBet.timeout);
          }, 5000);
          betslipBet.oddValue = foundOutcome.matchBetOutcomeOddValue;
        }
      }
    });
  }
};

const generateBetslipSystems = (obj) => {
  const betslip = obj;
  const nonBankers = betslip.bets.filter(item => !item.banker);

  betslip.systems = [];
  for (let i = 0; i < nonBankers.length; i += 1) {
    const system = {
      id: i + 1,
      of: nonBankers.length,
      active: false,
      stake: betslip.stake,
      combinations: Helpers.getNumberOfCombs(i + 1, nonBankers.length),
    };

    betslip.systems.push(system);
  }
};

const getRule = (name, ticketType, rules) => _.find(rules, item => parseInt(item.name, 10) === name
  && parseInt(ticketType, 10) === parseInt(item.ticketType, 10));

const formatRebetTicket = (data, state) => {
  const bets = [];

  data.bets.forEach((bet) => {
    const parsedBet = {
      key: bet.betOutcome.idMatchBetOutcome,
      keyBet: bet.bet.idBet,
      idMatchBet: bet.bet.idMatchBet,
      keyOutcome: bet.betOutcome.idMatchBetOutcome,
      matchId: bet.matchId,
      title: bet.matchName,
      subtitle: bet.bet.betDisplayName,
      outcome: bet.betOutcome.betOutcomeShortName,
      oddValue: bet.oddValue.toFixed(2),
      oddDisplay: {
        1: bet.oddValue.toFixed(2),
        2: Helpers.toLocaleOdd(parseFloat(bet.oddValue), 2, 2),
        3: Helpers.toLocaleOdd(parseFloat(bet.oddValue), 3, 2),
      },
      specialValue: bet.specialValue,
      banker: !!parseInt(bet.ticketBetBank, 10),
      change: null,
      matchDateTimeUTC: bet.matchDateTimeUTC,
    };

    if (!bet.isMatchStarted) {
      bets.push(parsedBet);
    } else {
      state.notifications.push({
        type: 'WARNING',
        message: state.translations['betslip.match_started'].replace('{{matchName}}', parsedBet.title),
      });
    }
  });

  return bets;
};

export default {
  INIT_META: (state, payload) => {
    Vue.set(state, 'sports', payload.sports);
    Vue.set(state, 'categories', payload.categories);
    Vue.set(state, 'tournaments', payload.tournaments);
    Vue.set(state, 'bets', payload.bets);
    Vue.set(state, 'betGroups', payload.betGroups);
    Vue.set(state, 'metaLoaded', true);
  },
  META_LOADED: (state, payload) => {
    Vue.set(state, 'metaLoaded', payload);
  },
  TOGGLE_OFFER_LOAD: (state, payload) => {
    Vue.set(state, 'offerLoaded', payload);
  },
  INIT_OUTRIGHTS_META: (state, payload) => {
    Vue.set(state, 'outrightsSports', payload.sports);
    Vue.set(state, 'outrightsCategories', payload.categories);
    Vue.set(state, 'outrightsTournaments', payload.tournaments);
  },
  INIT_OUTRIGHTS: (state, payload) => {
    Vue.set(state, 'outrightsMatches', payload);
  },
  INIT_MATCH: (state, payload) => {
    const match = payload;
    const { bets } = state;
    if (match && match.bets && bets) {
      match.bets = _.sortBy(match.bets, ['position']);
      match.bets = Helpers.groupBets(match.bets, bets);
    }
    Vue.set(state, 'activeMatch', match);
  },
  INIT_OFFER: (state, payload) => {
    parser.mapMatchBets(payload, state.bets);
    Vue.set(state, 'matches', payload);
  },
  INIT_TOP_OFFER: (state, topOffer) => {
    Vue.set(state, 'matches', topOffer.matches);
    Vue.set(state, 'sports', topOffer.sports);
    Vue.set(state, 'categories', topOffer.categories);
    Vue.set(state, 'tournaments', topOffer.tournaments);
  },
  INIT_EVENTVIEW_META: (state, payload) => {
    const tournaments = _.values(payload.tournaments);
    const sports = _.values(payload.sports);
    const sportsObj = {};
    const tournamentsObj = {};
    sports.forEach((item) => {
      const sport = item;
      sport.tournaments = [];
      sport.showTournaments = false;
      sportsObj[sport.id] = sport;
    });

    const filterTours = tournaments.filter(item => !_.startsWith(item.providerId.toLowerCase(), 's'));

    filterTours.forEach((item) => {
      const tournament = item;
      tournament.showMatches = false;
      tournament.matches = [];
      tournamentsObj[tournament.id] = tournament;
    });

    Vue.set(state, 'eventviewSports', sportsObj);
    Vue.set(state, 'eventviewTournaments', tournamentsObj);
  },
  TOGGLE_SPORT: (state, payload) => {
    Vue.set(state.sports[payload.id], 'showTournaments', true);
  },
  TOGGLE_TOURNAMENT: (state, payload) => {
    Vue.set(state.tournaments[payload.id], 'showMatches', true);
  },
  INIT_CONFIG: (state, payload) => {
    Vue.set(state, 'productConfig', payload.config);
    Vue.set(state, 'taxes', payload.config.taxes);
  },
  INIT_BONUS_CONFIG: (state, payload) => {
    Vue.set(state, 'bonusConfig', payload.data.bonuses[0]);
  },
  BETSLIP_SET_TABS: (state, payload) => {
    Vue.set(state.betslip, 'tabs', payload);
  },
  ADD_BET_TO_BETSLIP: (state, payload) => {
    const now = new Moment();
    const nowUTC = parseInt(Moment.utc(now).format('x'), 10);
    const canBePlayed = payload.matchDateTimeUTC - nowUTC > 0;

    const { betslip } = state;
    let index;

    let ruleName = 'MAX_BET_COUNT';
    let rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
    let ruleValue;

    switch (betslip.type) {
      case ticketTypes.COMBO:
      case ticketTypes.SYSTEM:
        index = _.findIndex(betslip.bets, { matchId: payload.matchId });

        // If match is not found, add them to betslip
        if (index < 0) {
          if (betslip.bets.length < parseInt(rule.conditions[0].value, 10)) {
            if (betslip.type === ticketTypes.SYSTEM) {
              // If ticket type is system, check for non-bankers before adding new bet
              rule = getRule(
                rulesConstants.MAX_NUMBER_OF_NON_BANKERS,
                betslip.type,
                state.productConfig.rules,
              );
              ruleValue = parseInt(rule.conditions[0].value, 10);
              const nonBankers = _.filter(betslip.bets, { banker: false }).length;

              if (ruleValue === nonBankers) {
                state.notifications.push({
                  type: 'WARNING',
                  message: rule.message,
                });
                return;
              }
            }
            if (canBePlayed) {
              betslip.bets.push(payload);
            } else {
              state.notifications.push({
                type: 'WARNING',
                message: state.translations['betslip.match_started'].replace('{{matchName}}', payload.title),
              });
            }
          } else {
            state.notifications.push({
              type: 'WARNING',
              message: rule.message,
            });
          }
        } else if (payload.key === betslip.bets[index].key) {
          // Toggle same betOutcomeId
          betslip.bets.splice(index, 1);
        } else {
          // Same match, different bet/outcome
          betslip.bets.splice(index, 1, payload);
        }

        if (betslip.type === ticketTypes.SYSTEM) {
          generateBetslipSystems(betslip);
        }
        break;

      case ticketTypes.SINGLE:
        index = _.findIndex(betslip.bets, { key: payload.key });

        if (index < 0) {
          if (betslip.bets.length < parseInt(rule.conditions[0].value, 10)) {
            if (canBePlayed) {
              betslip.bets.push(payload);
            } else {
              state.notifications.push({
                type: 'WARNING',
                message: state.translations['betslip.match_started'].replace('{{matchName}}', payload.title),
              });
            }
          } else {
            state.notifications.push({
              type: 'WARNING',
              message: rule.message,
            });
          }
        } else {
          betslip.bets.splice(index, 1);
        }

        ruleName = 'MIN_TICKET_PAYIN_SINGLE';
        rule = getRule(
          rulesConstants[ruleName],
          state.betslip.type, state.productConfig.rules,
        );

        ruleValue = parseFloat(rule.conditions[0].value);
        ruleValue *= (state.betslip.bets.length || 1);

        if (!betslip.stakeChanged) {
          Vue.set(state.betslip, 'stake', ruleValue);
        }
        break;

      default: console.log('UNKNOWN_TICKET_TYPE');
    }
  },
  SET_TICKET_TYPE: (state, payload) => {
    Vue.set(state.betslip, 'type', payload);
  },
  RESET_TICKET_HISTORY_STATE: (state) => {
    Vue.set(state, 'resetTrigger', !state.resetTrigger);
  },
  SET_TICKET_CHECK: (state, payload) => {
    const ticket = ticketCheckMapper(payload) || {};
    Vue.set(state, 'checkedTicket', ticket);
  },
  CHANGE_TICKET_TYPE: (state, payload) => {
    const { betslip } = state;
    const bets = [];

    if (betslip.type === ticketTypes.SINGLE) {
      betslip.bets.forEach((bet) => {
        const index = _.findIndex(bets, { matchId: bet.matchId });
        if (index >= 0) {
          bets.splice(index, 1);
        }
        bets.push(bet);
      });
      Vue.set(state.betslip, 'bets', bets);
    }

    Vue.set(state.betslip, 'type', payload);

    if (betslip.type === ticketTypes.SYSTEM) {
      generateBetslipSystems(betslip);
    }

    let ruleName = state.betslip.type === ticketTypes.SINGLE ? 'MIN_TICKET_PAYIN_SINGLE' : 'MIN_TICKET_PAYIN';

    let rule = getRule(
      rulesConstants[ruleName],
      state.betslip.type, state.productConfig.rules,
    );

    let ruleValue = parseFloat(rule.conditions[0].value);

    if (state.betslip.type === ticketTypes.SINGLE) {
      ruleValue *= (state.betslip.bets.length || 1);
    }

    if (!betslip.stakeChanged) {
      Vue.set(state.betslip, 'stake', ruleValue);
    } else if (ruleValue > betslip.stake) {
      state.notifications.push({
        type: 'WARNING',
        message: rule.message,
      });
    }


    ruleName = state.betslip.type === ticketTypes.SINGLE ? 'MAX_TICKET_PAYIN_PER_BET' : 'MAX_TICKET_PAYIN';
    rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
    ruleValue = parseFloat(rule.conditions[0].value);

    if (state.betslip.type === ticketTypes.SINGLE) {
      ruleValue *= (betslip.bets.length || 1);
    }

    if (state.betslip.stake > ruleValue) {
      state.notifications.push({
        type: 'WARNING',
        message: rule.message,
      });
    }
  },
  REMOVE_BET: (state, payload) => {
    const { betslip } = state;
    const index = _.findIndex(betslip.bets, { key: payload.key });
    betslip.bets.splice(index, 1);

    if (betslip.type === ticketTypes.SYSTEM) {
      generateBetslipSystems(betslip);
    }
  },
  CLEAR_BETSLIP: (state) => {
    const betslip = {
      bets: [],
      stake: 1,
      stakeChanged: false,
      type: state.betslip.type,
      tabs: state.betslip.tabs,
      showBetslip: false,
      systems: [],
      possibleWinnings: {
        max: 0,
        bonus: 0,
        bonusPercent: 0,
      },
      moneyDenominations: state.betslip.moneyDenominations,
    };

    Vue.set(state, 'betslip', betslip);
  },
  CLEAN_ACTIVE_MATCH: (state) => {
    Vue.set(state, 'activeMatch', null);
  },
  SET_DEFAULT_STAKE: (state) => {
    const ruleName = state.betslip.type === ticketTypes.SINGLE ? 'MIN_TICKET_PAYIN_SINGLE' : 'MIN_TICKET_PAYIN';

    const rule = getRule(
      rulesConstants[ruleName],
      state.betslip.type, state.productConfig.rules,
    );

    const ruleValue = parseFloat(rule.conditions[0].value);

    Vue.set(state.betslip, 'stake', ruleValue);
  },
  UPDATE_STAKE: (state, payload) => {
    const { betslip } = state;
    let stake = parseFloat(payload);
    let ruleName;
    let rule;
    let ruleValue;

    if (betslip.type !== ticketTypes.SINGLE) {
      ruleName = 'MIN_TICKET_PAYIN';
      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      stake = stake < ruleValue ? ruleValue : stake;

      ruleName = 'MAX_TICKET_PAYIN';
      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      if (stake > ruleValue) {
        state.notifications.push({
          type: 'WARNING',
          message: rule.message,
        });
        stake = ruleValue;
      }
    } else {
      // Check for min ticket payin
      ruleName = 'MIN_TICKET_PAYIN_SINGLE';
      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      if (stake < ruleValue) {
        stake = ruleValue;
        state.notifications.push({
          type: 'WARNING',
          message: rule.message,
        });
      }

      // Single ticket :: Payin per bet
      ruleName = 'MAX_TICKET_PAYIN_PER_BET';

      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      let betslipConfig = null;
      if (state && state.productConfig) {
        const { ticket, odds, taxes } = state.productConfig;

        betslipConfig = {
          ticket,
          odds,
          taxes,
        };
      }

      const singleStake = getSingleStake({ stake, bets: betslip.bets, betslipConfig });

      if (singleStake > ruleValue) {
        state.notifications.push({
          type: 'WARNING',
          message: rule.message,
        });
        stake = ruleValue * (state.betslip.bets.length || 1);
      }
    }

    Vue.set(state.betslip, 'stake', stake);
    Vue.set(state.betslip, 'stakeChanged', true);
  },
  TOGGLE_BANKER: (state, key) => {
    const { betslip } = state;
    const bet = _.find(betslip.bets, { key });
    let bankers = _.filter(betslip.bets, { banker: true }).length;
    let nonBankers = _.filter(betslip.bets, { banker: false }).length;
    let rule;
    let ruleName;
    let ruleValue;

    if (bet.banker) {
      nonBankers += 1;

      ruleName = 'MAX_NUMBER_OF_NON_BANKERS';
      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      if (nonBankers >= ruleValue) {
        state.notifications.push({
          type: 'WARNING',
          message: rule.message,
        });
        return;
      }
    } else {
      bankers += 1;

      ruleName = 'MAX_NUMBER_OF_BANKERS';
      rule = getRule(rulesConstants[ruleName], betslip.type, state.productConfig.rules);
      ruleValue = parseFloat(rule.conditions[0].value);

      if (bankers > ruleValue) {
        state.notifications.push({
          type: 'WARNING',
          message: rule.message,
        });
        return;
      }
    }

    bet.banker = !bet.banker;

    if (betslip.type === ticketTypes.SYSTEM) {
      generateBetslipSystems(betslip);
    }
  },
  TOGGLE_SYSTEM: (state, id) => {
    const { systems } = state.betslip;
    const index = systems.findIndex(item => item.id === id);
    if (index !== -1) {
      systems[index].active = !systems[index].active;
    }
  },
  REMOVE_FIRST_NOTIFICATION: (state) => {
    const { notifications } = state;

    notifications.shift();
    Vue.set(state, 'notifications', notifications);
  },
  REMOVE_NOTIFICATION: (state, index) => {
    const { notifications } = state;

    if (notifications[index]) {
      notifications.splice(index, 1);
    }
    Vue.set(state, 'notifications', notifications);
  },
  ADD_NOTIFICATION: (state, payload) => {
    state.notifications.push({
      type: payload.type.toUpperCase(),
      message: payload.message,
    });
  },
  TOGGLE_BETSLIP: (state) => {
    Vue.set(state.betslip, 'showBetslip', !state.betslip.showBetslip);
  },
  SET_MONEY_DENOMINATIONS: (state, payload) => {
    Vue.set(state.betslip, 'moneyDenominations', payload);
  },
  SET_ODD_TYPE: (state, payload) => {
    Vue.set(state, 'oddType', payload);
  },
  SET_MONEY_BALANCE: (state, payload) => {
    Vue.set(state, 'balance', payload);
  },
  SET_DEVICE_DATA: (state, payload) => {
    Vue.set(state, 'device', payload);
  },
  SET_COMAPANY_DATA: (state, payload) => {
    Vue.set(state, 'company', payload);
  },
  SET_COMPANY_CONFIG: (state, payload) => {
    Vue.set(state, 'companyConfig', payload);
  },
  SET_ENV: (state, payload) => {
    Vue.set(state, 'env', payload);
  },
  SET_TOTAL_ODDS: (state, payload) => {
    Vue.set(state.betslip, 'totalOdds', payload);
  },
  SET_ACTIVE_SPORT: (state, payload) => {
    Vue.set(state, 'activeSport', payload);
  },
  SET_ACTIVE_TOURNAMENT: (state, payload) => {
    Vue.set(state, 'activeTournament', payload);
  },
  SET_ACTIVE_CATEGORY: (state, payload) => {
    Vue.set(state, 'activeCategory', payload);
  },
  SET_ACTIVE_OUTRIGHTS_SPORT: (state, payload) => {
    Vue.set(state, 'activeOutrightsSport', payload);
  },
  SET_WORKING_TIME_BLOCKER: (state, payload) => {
    state.workingTimeBlocker = payload;
  },
  LOAD_CPVUUID: (state, payload) => {
    Vue.set(state, 'cpvUuid', payload);
  },
  UPDATE_APP_SETTINGS: (state, data) => {
    Vue.set(state, 'device', data.device);
    Vue.set(state, 'company', data.company);
    Vue.set(state, 'balance', data.device.balance);
    Vue.set(state, 'env', data.env);
    Vue.set(state, 'cpvUuid', data.product.cpvUuid);
    // state.device = data.device;
    // state.company = data.company;
    state.betslip.moneyDenominations = data.device.moneyDenominations;
    // state.balance = data.device.balance;
    // state.env = data.env;
    // state.cpvUuid = data.product.cpvUuid;
  },
  LOAD_TRANSLATIONS: (state, payload) => {
    Vue.set(state, 'translations', payload);
  },
  UPDATE_CLIENT_INTERVAL_ID: (state, payload) => {
    state.clientIntervalID = payload;
  },
  UPDATE_SERVER_TIMEOUT_ID: (state, payload) => {
    state.serverTimeoutID = payload;
  },
  SOCKET_UPDATESPORT: (state, payload) => {
    const sport = state.sports[payload.idSport];
    let outrightsSport;
    let eventviewSport;

    if (state.outrightsSports) {
      outrightsSport = state.outrightsSports[payload.idSport];
    }

    if (state.eventviewSports) {
      eventviewSport = state.eventviewSports[payload.idSport];
    }

    if (sport) {
      sport.active = !!payload.sportActive;
      sport.name = payload.sportName;
      sport.shortName = payload.sportShortName;
    }

    if (outrightsSport) {
      outrightsSport.active = !!payload.sportActive;
      outrightsSport.name = payload.sportName;
      outrightsSport.shortName = payload.sportShortName;
    }

    if (eventviewSport) {
      eventviewSport.active = !!payload.sportActive;
      eventviewSport.name = payload.sportName;
      eventviewSport.shortName = payload.sportShortName;
    }
  },
  SOCKET_UPDATECATEGORY: (state, payload) => {
    const category = state.categories[payload.idCategory];
    let outrightsCategory;

    if (state.outrightsCategories) {
      outrightsCategory = state.outrightsCategories[payload.idCategory];
    }

    if (category) {
      category.active = !!payload.categoryActive;
      category.name = payload.categoryName;
      category.shortName = payload.categoryShortName;
    }

    if (outrightsCategory) {
      outrightsCategory.active = !!payload.categoryActive;
      outrightsCategory.name = payload.categoryName;
      outrightsCategory.shortName = payload.categoryShortName;
    }
  },
  SOCKET_UPDATETOURNAMENT: (state, payload) => {
    const tournament = state.tournaments[payload.idTournament];
    let outrightsTournament;
    let eventviewTournament;

    if (state.outrightsTournaments) {
      outrightsTournament = state.outrightsTournaments[payload.idTournament];
    }

    if (state.eventviewTournaments) {
      eventviewTournament = state.eventviewTournaments[payload.idTournament];
    }

    if (tournament) {
      tournament.active = !!payload.tournamentActive;
      tournament.name = payload.tournamentName;
      tournament.shortName = payload.tournamentShortName;
    }

    if (eventviewTournament) {
      eventviewTournament.active = !!payload.tournamentActive;
      eventviewTournament.name = payload.tournamentName;
      eventviewTournament.shortName = payload.tournamentShortName;
    }

    if (outrightsTournament) {
      outrightsTournament.active = !!payload.tournamentActive;
      outrightsTournament.name = payload.tournamentName;
      outrightsTournament.shortName = payload.tournamentShortName;
    }
  },
  SOCKET_UPDATEBET: (state, payload) => {
    const { bets } = state;
    const bet = bets[payload.idBet];

    const { activeMatch } = state;

    if (bet) {
      bet.active = payload.betActive;
      bet.name = payload.betName;
      bet.shortName = payload.betShortName;
      bet.grouping = payload.betGroupingEnabled;
    }

    if (activeMatch && activeMatch.bets) {
      const matchBets = activeMatch.bets.filter(item => item.id === payload.idBet);

      if (matchBets) {
        matchBets.forEach((item) => {
          const matchBet = item;

          matchBet.active = payload.betActive;
          matchBet.name = payload.betName;
          matchBet.shortName = payload.betShortName;
          matchBet.grouping = payload.betGroupingEnabled;
        });
      }
    }
  },
  SOCKET_UPDATEMATCH: (state, payload) => {
    const offerMatches = state.matches;
    const { activeMatch } = state;

    if (offerMatches) {
      const match = offerMatches.find(item => item.id === payload.idMatch);
      if (match) {
        match.active = !!payload.active;
      }
    }

    if (activeMatch && activeMatch.id === payload.idMatch) {
      activeMatch.active = !!payload.active;
    }
  },
  SOCKET_UPDATEMATCHBETS: (state, payload) => {
    const offerMatches = state.matches;
    const { outrightsMatches } = state;
    const betslip = state.betslip.bets;

    const match = state.activeMatch;
    let currentMatch;
    if (match) {
      currentMatch = [match];
    }

    if (offerMatches) {
      updateMatchBets(offerMatches, payload);
    }
    if (currentMatch) {
      updateMatchBets(currentMatch, payload);
    }
    if (outrightsMatches) {
      updateMatchBets(outrightsMatches, payload);
    }
    if (betslip.length) {
      updateBetslipBets(betslip, payload);
    }
  },
  TICKET_REBET: (state, payload) => {
    const { betslip } = state;

    Vue.set(state.betslip, 'type', parseInt(payload.ticketType.id, 10));

    const bets = formatRebetTicket(payload, state);
    Vue.set(state.betslip, 'bets', bets);

    if (betslip.type === ticketTypes.SYSTEM) {
      generateBetslipSystems(betslip);
    }
  },
  UPDATE_BETSLIP_ODDS: (state, matches) => {
    const { betslip } = state;

    betslip.bets = _.map(betslip.bets, (item) => {
      const bet = item;
      const foundMatch = _.find(matches, { id: bet.matchId });
      const foundMatchBet = _.find(foundMatch.bets, { idMatchBet: bet.idMatchBet });
      const foundBetOutcome = _.find(foundMatchBet.outcomes, { idMatchBetOutcome: bet.keyOutcome });

      bet.oldOddValue = bet.oddValue;
      bet.oddValue = foundBetOutcome.value;

      bet.oldOddDisplay = bet.oddDisplay;
      bet.oddDisplay = {
        1: foundBetOutcome.value,
        2: Helpers.toLocaleOdd(parseFloat(foundBetOutcome.value), 2, 2),
        3: Helpers.toLocaleOdd(parseFloat(foundBetOutcome.value), 3, 2),
      };

      if (parseFloat(bet.oldOddValue) < parseFloat(foundBetOutcome.value)) {
        bet.oddChange = 'UP';
      } else if (parseFloat(bet.oldOddValue) > parseFloat(foundBetOutcome.value)) {
        bet.oddChange = 'DOWN';
      }

      return bet;
    });

    Vue.set(state.betslip, 'bets', betslip.bets);
  },
  CLOSE_STATS_MODAL: (state) => {
    Vue.set(state, 'modalState', false);
  },
  OPEN_STATS_MODAL: (state) => {
    Vue.set(state, 'modalState', true);
  },
  SET_USER_TYPE: (state, data) => {
    Vue.set(state, 'userType', data);
  },
  SET_ALTERNATIVE_STAKE: (state, data) => {
    Vue.set(state, 'alternativeStake', data);
  },
};
